<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey" />
</template>

<script>
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase')
        },

        data() {
            return {
                cards: [
                    { title: 'Role', apiMethod: 'Roles', form: () => import('../forms/RoleForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Role Claim', apiMethod: 'RoleClaims', parentForeignKey: 'roleId', form: () => import('../forms/RoleClaimForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'User Role', apiMethod: 'UserRoles', parentForeignKey: 'roleId', form: () => import('../forms/UserRoleForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Claims', value: 'roleId', isCard: true, table: () => import('../tables/RoleClaimsTable') },
                    { text: 'Users', value: 'roleId', isCard: true, table: () => import('../tables/UserRolesTable') },
                ],
                mainForm: () => import('../forms/RoleForm'),
                claimName: 'Roles',
                apiMethod: 'Roles',
            }
        }
    };
</script>
